"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 59 24",
    width: "59",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m58.08 0h-57.16a.86.86 0 0 0 -.92.78v22.44a.86.86 0 0 0 .92.78h57.16a.86.86 0 0 0 .92-.78v-22.44a.86.86 0 0 0 -.92-.78zm-48.39 22.43h-7.85v-20.86h7.85zm9.22 0h-7.65v-20.86h7.65zm19.1 0h-8.01v-4.12h-1.56v4.12h-8v-20.86h8v4.12h1.56v-4.12h8zm9.56 0h-8v-20.86h8zm9.59 0h-8v-20.86h8z",
    fill: "#93c01f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m25.44 17.48v-10.96l9.13 5.48z",
    fill: "#9ece06"
  }));
};

exports["default"] = _default;